import React, { createContext, useContext, useState } from "react";

const NewsfeedContext = createContext();

export const useNewsfeed = () => {
  const context = useContext(NewsfeedContext);
  if (!context) {
    throw new Error("useNewsfeed must be used within a NewsfeedProvider");
  }
  return context;
};

export const NewsfeedProvider = ({ children }) => {
  const [newContentAvailable, setNewContentAvailable] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const markNewContentAvailable = () => {
    setNewContentAvailable(true);
  };

  const clearNewContent = () => {
    setNewContentAvailable(false);
  };

  const triggerRefresh = () => {
    setNewContentAvailable(false);
    setRefreshTrigger(prev => prev + 1);
  };

  const value = {
    newContentAvailable,
    markNewContentAvailable,
    clearNewContent,
    triggerRefresh,
    refreshTrigger,
  };

  return (
    <NewsfeedContext.Provider value={value}>
      {children}
    </NewsfeedContext.Provider>
  );
};